<script>
    import ListViewItemComponent from "../ListViewItemComponent.svelte";

    export let config;

    $ : contentItems = loadContentItems(108);

    function loadContentItems(id) {
        return fetch(config.model_root + 'shared/contents/load_contents_details.php?mid=' + id + "&order=date&maxItems=2", {
            method: "GET"
        })
            .then(response => response.json());
    }
</script>

<div class="container px-0 px-sm-4">
    {#await contentItems}
        <p class="alert alert-light">
            <i class="fas fa-circle-notch fa-spin me-1"></i> Lade Inhalte...
        </p>
    {:then items}

        {#each items as content}
            {#if content.cvisible == 1}
                <ListViewItemComponent {config} {content} showDate="SHOW"/>
            {/if}

        {/each}

    {:catch error}
        <p style="color: red">{error.message}</p>
    {/await}
</div>

